export default {
  methods: {
    logout () {
      this.$store.commit('clearState')
      this.$router.push('/login')
    },
    backPage () {
      this.$router.push(this.$store.state.historyPage)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/header.js